import { useState } from "react";
import { useNavigate } from "react-router-dom";
import type { IdentificationDocumentListItemResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import { AppRouting } from "web_myplann/Infrastructure/Utils/UrlUtils";
import type { PaperworkDocType } from "web_myplann/Profile/Constants/paperworkDocTypes";
import { usePaperworkDocumentForm } from "web_myplann/Profile/Hooks/usePaperworkDocumentForm";
import type { PaperworkNavigationState } from "web_myplann/Profile/Types/PaperworkNavigationState";
import { useLocationState } from "web_myplann/Shared/Hooks/useLocationState";

type PaperworkAddStep = "form" | "success";

export const usePaperworkAddFlow = (
	type: PaperworkDocType,
	document?: IdentificationDocumentListItemResponseDTO,
) => {
	const navigate = useNavigate();
	const navigationState = useLocationState<PaperworkNavigationState>();
	const isUpdate = document != null;
	const [step, setStep] = useState<PaperworkAddStep>("form");
	const [reminderSet, setReminderSet] = useState(false);
	const documentForm = usePaperworkDocumentForm(type, document);

	const exit = () =>
		navigate(
			document
				? AppRouting.MyPlann.Profile.PaperworkDetail.path(document.id)
				: AppRouting.MyPlann.Profile.Paperwork.path(),
			{ state: navigationState },
		);
	const backToTypeList = () =>
		navigate(
			document
				? AppRouting.MyPlann.Profile.PaperworkEdit.path(document.id)
				: AppRouting.MyPlann.Profile.PaperworkAdd.path(),
			{ state: navigationState },
		);

	return {
		step,
		reminderSet,
		isUpdate,
		documentForm,
		submitForm: (result: { reminderSet: boolean }) => {
			setReminderSet(result.reminderSet);
			setStep("success");
		},
		goBack: () => {
			if (documentForm.isSubmitting) return;

			navigate(AppRouting.MyPlann.Profile.Paperwork.path(), {
				state: navigationState,
			});
		},
		addAnother: backToTypeList,
		exit,
	};
};
